import { BUDGET_SOURCE, BUDGET_STRUCTURE_STATUS } from 'domain/shared/newProject';
import { ControlData } from '../types';
import { DATE_FORMAT, EMPTY_VALUE_INDICATOR } from 'framework/utils';
import { BudgetStructure } from 'domain/shared/newProject/dashboard/types';
import moment from 'moment';

const formatSignedValue = (value: number, suffix = '') => `${value > 0 ? '+' : ''}${value}${suffix}`;

export const getProgressMessageOverride = (data: ControlData) => {
  const plannedProgress = data.forecast?.plannedProgress;
  const actualProgress = data.forecast?.actualProgress;

  if (!plannedProgress || !actualProgress) {
    return undefined;
  }

  const diff = actualProgress - plannedProgress;
  return `${plannedProgress}% / ${actualProgress}% (${formatSignedValue(diff, ' p.p.')})`;
};

export const getBudgetMessageOverride = (data: ControlData) => {
  const sowBudgetStructure = (data.budget?.structure || []).find(
    (budgetStructure: BudgetStructure) =>
      budgetStructure?.source === BUDGET_SOURCE.SOW && budgetStructure.status === BUDGET_STRUCTURE_STATUS.APPROVED,
  );
  const forecastCompletionBudgetHours = data.forecast?.forecastCompletionBudgetHours
    ? Number(data.forecast?.forecastCompletionBudgetHours)
    : null;
  const formattedSow = sowBudgetStructure?.hours ? Number(sowBudgetStructure?.hours) : null;

  let str = '';

  str += formattedSow ? `${formattedSow.toFixed(2)} h` : EMPTY_VALUE_INDICATOR;
  str += ' / ';
  str += forecastCompletionBudgetHours ? `${forecastCompletionBudgetHours.toFixed(2)} h` : EMPTY_VALUE_INDICATOR;

  if (forecastCompletionBudgetHours && formattedSow) {
    const deltaPercent = Math.round(((forecastCompletionBudgetHours - formattedSow) / formattedSow) * 100);
    str += ` (${formatSignedValue(deltaPercent, '%')})`;
  }
  return str;
};

export const getTimelineMessageOverride = (
  data: ControlData,
  formatDate: (date: string | Date, format: string | undefined) => string | null,
) => {
  const budgetEndDate = data.budget?.endDate;
  const forecastCompletionDate = data.forecast?.forecastCompletionDate;

  if (!budgetEndDate || !forecastCompletionDate) {
    return undefined;
  }

  const deltaDays = moment(forecastCompletionDate).diff(moment(budgetEndDate), 'days');
  return `${formatDate(budgetEndDate, DATE_FORMAT.FULL_DATE)} / ${formatDate(forecastCompletionDate, DATE_FORMAT.FULL_DATE)} (${formatSignedValue(deltaDays, 'd')})`;
};
